import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useArrayWithIndex } from '../../../../helpers/use/useArray';
import SlideSearchItemSkeleton from '../../Common/Item/SlideSearchItemSkeleton';
const SlideSearchItemSkeletons = () => {
    const rowDummies = useArrayWithIndex(3);
    const columnDummies = useArrayWithIndex(2);
    return (_jsx(_Fragment, { children: rowDummies.map(({ index: rowIndex }) => (_jsx("div", Object.assign({ className: 'slide_search_list_content_item_row' }, { children: columnDummies.map(({ index: columnIndex }) => (_jsx(SlideSearchItemSkeleton, {}, `${rowIndex}_${columnIndex}`))) }), rowIndex))) }));
};
export default SlideSearchItemSkeletons;
